import axiosInstance from './axiosInstance';
import config from '../config';
import { StockLevel } from '../types/stockLevels.types';

const API_URL = `${config.API_BASE_URL}/StockLevels`;

export const stockLevelsService = {
  getAll: async (itemId?: number, warehouseId?: number, branchId?: number): Promise<StockLevel[]> => {
    const params = new URLSearchParams();
    if (itemId) params.append('itemId', itemId.toString());
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    if (branchId) params.append('branchId', branchId.toString());
    
    const url = params.toString() ? `${API_URL}?${params.toString()}` : API_URL;
    const response = await axiosInstance.get<StockLevel[]>(url);
    return response.data;
  },

  getById: async (id: number): Promise<StockLevel> => {
    const response = await axiosInstance.get<StockLevel>(`${API_URL}/${id}`);
    return response.data;
  },

  getByItem: async (itemId: number): Promise<StockLevel[]> => {
    const response = await axiosInstance.get<StockLevel[]>(`${API_URL}/by-item/${itemId}`);
    return response.data;
  },

  getByWarehouse: async (warehouseId: number): Promise<StockLevel[]> => {
    const response = await axiosInstance.get<StockLevel[]>(`${API_URL}/by-warehouse/${warehouseId}`);
    return response.data;
  },

  getByBranch: async (branchId: number): Promise<StockLevel[]> => {
    const response = await axiosInstance.get<StockLevel[]>(`${API_URL}/by-branch/${branchId}`);
    return response.data;
  },
};